export enum PlanState {
  Active = 'Active',
  Old = 'Old',
  Special = 'Special'
}
